// CSAT modal palette — a DARK theme drawn from the Layers Crop marketing site's dark sections
// (https://layerscrop.com/en/): navy surface, white text, teal/cyan accents. Kept local to the
// feature so this restyling stays decoupled from the app's own theme.
export const csatTheme = {
  surface: '#082d40', // modal background — brand navy (the site's dark sections)
  text: '#ffffff', // primary text on the dark surface
  textMuted: 'rgba(255, 255, 255, 0.65)', // subtitle / secondary text
  label: 'rgba(255, 255, 255, 0.8)', // field labels
  teal: '#17ecb2', // signature accent — rating stars, input focus, CTA gradient start
  cyan: '#18e4ed', // CTA gradient end / secondary accent
  starEmpty: 'rgba(255, 255, 255, 0.25)', // unfilled rating stars
  inputBg: 'rgba(255, 255, 255, 0.08)', // ghost input fill on dark (the site's card treatment)
  inputBorder: 'rgba(255, 255, 255, 0.18)', // input border
  placeholder: 'rgba(255, 255, 255, 0.4)', // input placeholder
  cancelBorder: 'rgba(255, 255, 255, 0.3)', // ghost cancel button border
  error: '#ff6467', // validation (the site's red-400 — readable on navy)
  ctaGradient: 'linear-gradient(135deg, #17ecb2 0%, #18e4ed 100%)',
  ctaText: '#082d40', // navy text on the teal CTA
  radius: '16px'
}
